import { CDNAudioAddress } from '../models/constants'

const audioFiles = {
  onesecond: `${CDNAudioAddress}/onesecond.mp3`,
  speechrecognition: `${CDNAudioAddress}/blip.mp3`,
  microphoneopen: `${CDNAudioAddress}/microphone-open.mp3`,
  microphoneclose: `${CDNAudioAddress}/microphone-close.mp3`
}

export { audioFiles }
